// extracted by mini-css-extract-plugin
export var actionButton = "_kk-0";
export var fileInput = "_kk-2";
export var paperclip = "_kk-1";